import { useTranslation } from 'react-i18next';
import ConfirmationDialog from 'components/ConfirmationDialog';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { selectIsRemoteMediaPlaybackBlocked } from 'features/streaming/streamingSlice';
import { enableMediaPlaybackClicked } from 'features/streaming/thunks/enableMediaPlaybackClicked';

const MediaPermissionRecoveryModal = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();
  const blocked = useAppSelector(selectIsRemoteMediaPlaybackBlocked);

  if (!blocked) {
    return null;
  }

  return (
    <ConfirmationDialog
      open
      preventClose
      hideCloseButton
      title={t('media_playback_blocked.title')}
      description={t('media_playback_blocked.description')}
      okText={t('media_playback_blocked.btn_ok_label')}
      onOk={() => dispatch(enableMediaPlaybackClicked())}
      okButtonProps={{ autoFocus: true }}
    />
  );
};

export default MediaPermissionRecoveryModal;
